<template>
  <section
    class="p-6 flex flex-col justify-center"
    style="height: calc(100% - 5rem)"
  >
    <p class="text-2xl sm:text-3xl text-center">
      Oh no, you’ve found our junior developer’s homepage!
    </p>
    <div class="flex flex-col items-center space-y-5 lg:space-y-10">
      <div class="md:w-150 h-auto">
        <img
          src="@/assets/images/svg/not-found.svg"
          class="w-full h-full"
          alt="not found"
        />
      </div>
      <p class="text-lg sm:text-2xl text-center">
        Despite sleeping on the chair most of the day <br />
        our junior web developer still finds time to do some coding…
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>
